// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ScheduledSettingsTab_scheduledSettingsTab__2KA-Q {\n  width: 100%; }\n  .ScheduledSettingsTab_scheduledSettingsTab__2KA-Q .ScheduledSettingsTab_tabHeader__2-KG_ {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 16px; }\n    .ScheduledSettingsTab_scheduledSettingsTab__2KA-Q .ScheduledSettingsTab_tabHeader__2-KG_ h3 {\n      margin: 0;\n      font-size: 16px;\n      font-weight: 600; }\n", ""]);
// Exports
exports.locals = {
	"scheduledSettingsTab": "ScheduledSettingsTab_scheduledSettingsTab__2KA-Q",
	"tabHeader": "ScheduledSettingsTab_tabHeader__2-KG_"
};
module.exports = exports;
